import React, { useContext } from 'react';
import { Type } from '@spotify-internal/encore-web-v6';
import { useT } from '../../../../../features/src/i18n/index';
import { TRACK_CAT } from '../constants';
import styled from 'styled-components';
import {
  FooterTextLinkType,
  FooterTextLink,
} from '../components/FooterTextLink';
import { FrodorModulesContext } from '@spotify-internal/frodor-modules';

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;

type HelpfulLink = FooterTextLinkType & { label: string };

export const HelpfulLinks = () => {
  const t = useT();
  const { isFrodor } = useContext(FrodorModulesContext);
  const links: HelpfulLink[] = [
    {
      href: 'https://www.spotify.com/about-us/contact/',
      track: [TRACK_CAT, 'About'],
      dataTestId: 'footer-about',
      label: t('FRODOR_2b48af', 'About', ''),
      external: true,
    },
    {
      href: 'https://newsroom.spotify.com',
      track: [TRACK_CAT, 'Press & Media'],
      dataTestId: 'footer-press-and-media',
      label: t(
        'FRODOR_f24f14',
        'Press & Media',
        'Press means newspapers or journalists viewed collectively',
      ),
      external: true,
    },
    {
      href: 'https://artists.spotify.com/providers',
      track: [TRACK_CAT, 'Providers'],
      dataTestId: 'footer-providers',
      label: t('FRODOR_83327b', 'Providers', ''),
      external: true,
    },
    {
      href: isFrodor ? '/contact' : 'https://artists.spotify.com/contact',
      track: [TRACK_CAT, 'Contact Us'],
      dataTestId: 'footer-contact',
      label: t('FRODOR_51f8e4', 'Contact Us', ''),
      useInternalNavigation: isFrodor,
    },
  ];
  return (
    <>
      <Type variant="finaleBold" semanticColor="textBase">
        {t(
          'FRODOR_0aeec8',
          'Helpful Links',
          'Link refers to web link',
        ).toUpperCase()}
      </Type>
      <LinkList>
        {links.map(link => {
          return (
            <FooterTextLink key={link.label} {...link}>
              {link.label}
            </FooterTextLink>
          );
        })}
      </LinkList>
    </>
  );
};
